import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import style from './style.module.less';

export const ImportStatusUnknown = () => {
  return (
    <div className={style['import-status-unknown']}>
      <FormattedMessage {...messages.unknownStatus} />
    </div>
  );
};
